import type { ArTaskRow, ArTasksSummaryResponse } from '@erp/rpc';
import { ARInvoiceDetailSlidein } from '@/components/accounts-receivable/invoice-detail/ar-invoice-detail-slidein';
import { SalesOrderDetailSlidein } from '@/components/accounts-receivable/sales-order-detail/sales-order-detail-slidein';
import { TaskQueueReassignDialog } from '@/pages/authenticated/tasks/TaskQueueReassignDialog';
import { ArTasksCloseDialog } from './ArTasksCloseDialog';
import { ArTasksAssignmentRulesSheet } from './ArTasksAssignmentRulesSheet';

/** At most one overlay is open at a time; the page resets this to close it. */
export interface ArTasksOverlayState {
  invoiceId: string | null;
  salesOrderId: string | null;
  reassignTaskIds: string[];
  closeTasks: Array<Pick<ArTaskRow, 'taskId' | 'kind'>>;
  rulesOpen: boolean;
}

/**
 * Every slide-in and dialog the AR Tasks page opens. All are existing
 * components except the close dialog and the assignment rules sheet.
 */
export function ArTasksOverlays({
  state,
  onDismiss,
  onDone,
  taskTypeIds,
}: {
  state: ArTasksOverlayState;
  /** Closed without changing anything. */
  onDismiss: () => void;
  /** An action changed tasks: clear selection and refresh metrics. */
  onDone: () => void;
  taskTypeIds: ArTasksSummaryResponse['taskTypeIds'];
}) {
  const closeOn = (open: boolean) => {
    if (!open) onDismiss();
  };
  return (
    <>
      {state.invoiceId && (
        <ARInvoiceDetailSlidein
          invoiceId={state.invoiceId}
          isOpen
          onOpenChange={closeOn}
        />
      )}
      <SalesOrderDetailSlidein
        isOpen={state.salesOrderId != null}
        onOpenChange={closeOn}
        salesOrderId={state.salesOrderId ?? undefined}
      />
      <TaskQueueReassignDialog
        open={state.reassignTaskIds.length > 0}
        onOpenChange={closeOn}
        taskIds={state.reassignTaskIds}
        onAssigned={onDone}
      />
      <ArTasksCloseDialog
        open={state.closeTasks.length > 0}
        onOpenChange={closeOn}
        tasks={state.closeTasks}
        onClosed={onDone}
      />
      <ArTasksAssignmentRulesSheet
        open={state.rulesOpen}
        onOpenChange={closeOn}
        taskTypeIds={taskTypeIds}
      />
    </>
  );
}
